import React from 'react'
import {
	BranchAverage,
	BranchCustomer,
	BranchHourlyTurnover,
	BranchTotalBig,
	BranchTotalSmall,
	BranchWorkingHours,
	DifferenceIcon
} from 'media/icons'
import { StyledCardPrototype } from './styled'

const CardPrototype = ({
	t,
	name,
	cashRegistersCount,
	allowedCashRegistersCount,
	isTotalIconBig,
	total,
	cashDifference,
	avgBill,
	customersCount,
	realHours,
	totalPerRealTimeHours
}) => (
	<StyledCardPrototype>
		<div className='branch__header'>
			<h3>{name}</h3>
			<span>{t('dashboard_section.active_cash_registers')}<span>{allowedCashRegistersCount}</span>/{cashRegistersCount}</span>
		</div>
		<div className='branch__content'>
			<div className='branch__content_block'>
				<div className='flexblock branch__content_block__top'>
					<div className='branch__content_block__icon'>
						{isTotalIconBig ? <BranchTotalBig /> : <BranchTotalSmall />}
					</div>
					<div className='branch__content_block__info'>
						<h5>{t('dashboard_section.total')}</h5>
						<h3 className='branch__content_block__total'>
							{total}
						</h3>
					</div>
				</div>
			</div>
			<div className='branch__content_block'>
				<div className='flexblock branch__content_block__bottom branch__content_block__difference'>
					<div className='branch__content_block__icon'>
						<DifferenceIcon />
					</div>
					<div className='branch__content_block__info'>
						<h5>{t('dashboard_section.checkout_difference')}</h5>
						<h3>
							{cashDifference}
						</h3>
					</div>
				</div>
			</div>
			<div className='branch__content_block'>
				<div className='flexblock branch__content_block__bottom branch__content_block__average'>
					<div className='branch__content_block__icon'>
						<BranchAverage />
					</div>
					<div className='branch__content_block__info'>
						<h5>{t('dashboard_section.Ø_purchase_amount')}</h5>
						<h3 className='branch__content_block__avg-check'>
							{avgBill}
						</h3>
					</div>
				</div>
			</div>
			<div className='branch__content_block'>
				<div className='flexblock branch__content_block__bottom branch__content_block__customers'>
					<div className='branch__content_block__icon'>
						<BranchCustomer />
					</div>
					<div className='branch__content_block__info'>
						<h5>{t('dashboard_section.customers')}</h5>
						<h3 className='branch__content_block__customers'>
							{customersCount}
						</h3>
					</div>
				</div>
			</div>
			<div className='branch__content_block'>
				<div className='flexblock branch__content_block__bottom branch__content_block__working_hours'>
					<div className='branch__content_block__icon'>
						<BranchWorkingHours />
					</div>
					<div className='branch__content_block__info'>
						<h5>{t('dashboard_section.working_hours')}</h5>
						<h3 className='branch__content_block__working_hours'>
							{realHours}
						</h3>
					</div>
				</div>
			</div>

			<div className='branch__content_block'>
				<div className='flexblock branch__content_block__bottom branch__content_block__hourly_turnover'>
					<div className='branch__content_block__icon'>
						<BranchHourlyTurnover />
					</div>
					<div className='branch__content_block__info'>
						<h5>{t('statistic_section.strings.hourly_turnover')}</h5>
						<h3 className='branch__content_block__hourly_turnover'>
							{totalPerRealTimeHours}
						</h3>
					</div>
				</div>
			</div>
		</div>
	</StyledCardPrototype>
)

export default CardPrototype
